import { isLegacyBrokenSafeUser } from '@/constants/legacy-broken-safes'
import { deriveDepositWalletAddress } from '@/lib/wallets/polymarket-deposit'
import type { Address } from 'viem'

export type PolymarketActiveWallet = 'safe' | 'deposit'

/**
 * Resolve the user's Polymarket wallet address (Safe or deposit wallet).
 * - userId on legacy-broken-safe list → derive deposit wallet (Safe is rejected by Polymarket V2)
 * - polymarketSafe NOT NULL + polymarketActiveWallet 'deposit' → legacy user who
 *   switched to the deposit wallet via the wallet switcher
 * - polymarketSafe NOT NULL (activeWallet null/'safe') → existing Safe user, return Safe address
 * - polymarketSafe NULL     → new deposit-wallet user, derive deposit wallet
 *
 * Always returns a non-null address for any registered user.
 */
export function resolvePolymarketWalletAddress(
	user: {
		walletAddress: string
		polymarketSafe: string | null
		polymarketActiveWallet?: string | null
	},
	userId?: string | null
): Address {
	if (userId && isLegacyBrokenSafeUser(userId)) {
		return deriveDepositWalletAddress(user.walletAddress)
	}
	if (user.polymarketSafe && user.polymarketActiveWallet !== 'deposit') {
		return user.polymarketSafe as Address
	}
	return deriveDepositWalletAddress(user.walletAddress)
}
